module.exports = __webpack_public_path__ + "img/logo-splash.208b09b5.png";